import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ParametrosService } from '../../services/parametros.service';

@Component({
    selector: 'app-template-registo',
    templateUrl: './template-registo.component.html',
    styleUrls: ['./template-registo.component.scss'],
    standalone: false
})
export class TemplateRegistoComponent implements OnInit {
  subTitle: string = "";
  actividades: any[] = [];
  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    if(this.route.snapshot.params.persona ===  "persona-natural"){
      this.subTitle = "persona natural";
    }else{
      this.subTitle = "persona jurídica";
    }
  }

}
